import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import { getPermissionKey } from '../../../helper/permissions';
import { BriefcaseBusiness, Building2, Check, ChevronRight } from 'lucide-react';
import Icons from '../../../assets/icons';
import { Progress } from 'antd';
import LanguageTranslator from '../../../locals/LanguageTranslator';

function OnboardingSidebar(props) {
    const { menuData, setMenuData, submenuArray, setSubmenuArray, currentStep, setCurrentStep, percentageData } = props;

    const dispatch = useDispatch();

    const authStore = useSelector((state) => state.authStore);

    const convertSectionsData = (input, progressMap = {}) => {
        const toSnakeCase = str =>
            str
                .toLowerCase()
                .replace(/&/g, "and")
                .replace(/[^\w\s]/g, "")
                .trim()
                .replace(/\s+/g, "_");

        const output = {};
        const allSubSections = [];

        input.forEach(sectionObj => {
            const sectionKey = toSnakeCase(sectionObj.section);
            const businessType= sectionObj?.business_type ? sectionObj?.business_type: null;

            const steps = sectionObj.subSection.map(label => {
                const stepKey = toSnakeCase(label);
                const stepObj = {
                    key: stepKey,
                    label: label,
                    progress: progressMap[stepKey] || 0
                };

                allSubSections.push(label); // store in global list
                return stepObj;
            });

            output[sectionKey] = {
                section: sectionObj.section,
                steps,
                businessType
            };
        });

        return { sections: output, allSubSections };
    }

    // function to get the menu bar
    useEffect(() => {
        if(submenuArray?.length == 0) {
            let payload = { smEmail: props?.vendorData?.smEmail, type: props?.vendorData?.smEmail ? "retailer" : undefined, smMobileNumber: props?.vendorData?.smMobileNumber };
            dispatchHandler(dispatch, 'vendorOnboardingGetMenuRequest', payload, getPermissionKey("common", "commonfunctionality", "upload"))
        }
    }, []);

    useEffect(() => {
        if (authStore?.vendorOnboardingGetMenuData?.isSuccess) {
            const { sections, allSubSections } = convertSectionsData(authStore?.vendorOnboardingGetMenuData?.data?.resource || []);
            setMenuData(sections || {});
            setSubmenuArray(allSubSections || []);
        }
    }, [authStore?.vendorOnboardingGetMenuData?.isSuccess]);

    useEffect(() => {
        if(!currentStep?.key && submenuArray?.length !== 0) {
            setCurrentStep({key: submenuArray?.[0], stepCount: 1});
        }
    }, [submenuArray]);

    const getHeadingIcon = {
        "Company Details": <Building2 size={16} color='#67768E'/>,
        "Basic Details": <Building2 size={16} color='#67768E'/>,
        "Business Details": <BriefcaseBusiness size={16} color='#67768E'/>,
        "ESG Details": <Icons.Esg/>,

    }

    const getCurrSectionIcon = (status)=>{
        switch (status) {
            case 'inActive':
                return <div className={`absolute rounded-full h-[7px] w-[7px] bg-[#E3E3E3] top-[12px] left-[-20px]`}></div>
                break;

            case 'active':
                return <div style={{boxShadow: '0px 0px 3.27px 0px var(--primary-color)'}} className={`absolute rounded-full p-[2px] bg-primary_w_less_opacity top-[8px] left-[-23px] flex items-center justify-center`}><div className='h-[9px] w-[9px] bg-primaryColor rounded-full'></div></div>
                break;

            case 'completed':
                return <div className={`p-[3px] absolute rounded-full h-[18px] w-[18px] bg-[#20BF6B] top-[6px] left-[-25px] flex items-center justify-center`}><Check size={15} color='white' strokeWidth={3} /></div>
                break;
                    
            case 'prevIncomplete':
                return <div className={`absolute top-[6px] left-[-24px]`}><Icons.WarningCircle/></div>
                break;

            default:
                break;
        }
    }

    const getPerVal = (type) => {
        let data = {
            businessCompliancesPercentage: "business_registration_and_compliances",
            categorySpecificPercentage: "category_specific_details",
            certificationCompliancePercentage: "certifications_and_compliance",
            companyContactPercentage: "company_and_contact_details",
            documentUploadPercentage: "document_upload_section",
            esgCertificationPercentage: "esg_certifications_and_documentation",
            esgParticularsPercentage: "esg_particulars",
            company_and_contact_details: "companyContactPercentage",
            business_registration_and_compliances: "businessCompliancesPercentage",
            category_specific_details: "categorySpecificPercentage",
            certifications_and_compliance: "certificationCompliancePercentage",
            document_upload_section: "documentUploadPercentage",
            esg_particulars: "esgParticularsPercentage",
            esg_certifications_and_documentation: "esgCertificationPercentage"
        }
        return Number(percentageData?.[data?.[type]] || 0)
    }

    return (
        <div className='stickyProgressDetailsSection sticky top-[86px] min-w-[310px] rounded-[9px] border border-[#E1E1E1] bg-white'>
            <div className='px-[20px] py-2 2xl:py-[10px] relative bg-[#FBFBFB] rounded-[9px]'>
                <div className='mb-0.5 flex items-end justify-between gap-3'>
                    <div>
                        <LanguageTranslator tag='h3' className='mb-0 text-base font-semibold text-[#111111]'>{props?.viewMode ? 'Vendor Details' : 'Vendor Onboading'}</LanguageTranslator>                
                        <p className='mb-0 text-[9px] text-[#6C6C6C]'>Your Progress</p>
                    </div>
                    <div className='shrink-0'>
                        {/* <ChevronRight size={20}/> */}
                        {/* <p className='mb-[-2px] text-xs font-medium text-[#111D31]'>{60}%</p> */}
                    </div>
                </div>

                {/* progress line */}
                {/* <div className='absolute left-0 bottom-[-1px] z-[1] h-[2px] bg-primary' style={{width: `${60}%`}}></div> */}
            </div>
            <div className='px-[20px] py-2 2xl:py-[16px] border-t border-[#E1E1E1] space-y-4 2xl:space-y-6'>
                {Object.keys(menuData || {})?.map((mainKey) =>
                    <div key={mainKey}>
                        <div className='mb-1.5 2xl:mb-2 flex items-center gap-2'>
                            <div className='shrink-0'>{getHeadingIcon[menuData?.[mainKey]?.section]}</div>
                            <h2 className='mb-0 text-[15px] font-semibold'>{menuData?.[mainKey]?.section}</h2>
                        </div>
                        <div className='relative pl-[24px]'>
                            
                            {/* line */}
                            <div className='absolute top-[12px] left-[7px] h-[calc(100%-50px)] border-r border-dashed border-[#E3E3E3]'></div>

                            {menuData?.[mainKey]?.steps?.map((subMenu) => {
                                let status;
                                
                                if(currentStep?.key === subMenu?.label) {
                                    status = 'active'
                                } else if(getPerVal?.(subMenu?.key) == 100) {
                                    status = 'completed'
                                } 
                                // else if(submenuArray?.indexOf(subMenu?.label)+1 < currentStep?.stepCount || getPerVal?.(subMenu?.key) < 100) {
                                //     status = 'prevIncomplete'
                                // } 
                                else {
                                    status = 'inActive'
                                }
                                return (<div className={`mb-1 last:mb-0 relative flex items-start`}>

                                    {/* icon */}
                                    {getCurrSectionIcon(status)}
                                    {/* status = 'prevIncomplete' ? "#FAD271" : prevIncomplete case of progress bar */}
                                    <div className={`px-2 py-1.5 w-full rounded-[5px] ${status === 'active' ? 'bg-primary_w_less_opacity' : ''}`}>
                                        <h5 className={`mb-0 2xl:mb-0.5 ${status === 'active' ? 'text-xs font-semibold text-primary' : 'text-[11px] font-medium'}`}>{subMenu?.label}</h5>
                                        <div className='flex items-center gap-4'>
                                            <Progress strokeColor={status === 'active' ? 'var(--primary-color)' : status === 'completed' ? '#20BF6B' : 'var(--primary-color)'} className='max-w-[80px] shrink-0' strokeWidth={4} percent={getPerVal?.(subMenu?.key) || 0} showInfo={false} />
                                            <span className='text-[9px] font-medium text-[#67768E]'>{getPerVal?.(subMenu?.key)}%</span>
                                        </div>
                                    </div>
                                </div>)
                            }
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default OnboardingSidebar